// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { AppAccessControlAreaId } from './AppAccessControlAreaId'
import {
  AppAccessControlAreaNavigation,
  AppAccessControlAreaNavigationIcon,
} from './AppAccessControlAreaNavigation'
import { AppAccessControlAreaRoutes } from './AppAccessControlAreaRoutes'

const LazyAppAccessControlComponent = lazy(
  () => import('./AppAccessControlArea'),
)

const AppAccessControlComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAppAccessControlComponent />
  </SuspenseLoadingWrapper>
)

export const AppAccessControlArea = {
  id: AppAccessControlAreaId,
  requiredRight: BoumRight.AREA_SIGNUP_ALLOWLIST,
  Icon: AppAccessControlAreaNavigationIcon,
  NavigationComponent: AppAccessControlAreaNavigation,
  route: {
    path: AppAccessControlAreaRoutes.route,
    component: AppAccessControlComponent,
  },
}
